export default __webpack_public_path__ + "static/media/D2.f14d8cec.png";